// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of ProjectFileLog
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## ProjectFileLog Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProjectFileLog.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## ProjectFileLog Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProjectFileLog.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectFileLog Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProjectFileLog.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectFileLog Download File
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const DownloadFile = async (option) => {
  const response = await $api.blob(
    Endpoints.ProjectFileLog.DownloadFile(option)
  );
  // const checker = await ResponseChecker(defaultMessages, response);
  return response;
};
// ## ProjectFileLog Get Directories And Files
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetDirectoriesAndFiles = async (option) => {
  const response = await $api.get(
    Endpoints.ProjectFileLog.GetDirectoriesAndFiles(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## ProjectFileLog UploadFile
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const UploadFile = async (form) => {
  const response = await $api.post(Endpoints.ProjectFileLog.UploadFile(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectFileLog CompressFile
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const CompressFile = async (form) => {
  const response = await $api.blob(
    Endpoints.ProjectFileLog.CompressFile(),
    form,
    "post"
  );
  // const checker = await ResponseChecker(defaultMessages, response);
  return response;
};

// ## ProjectFileLog Delete File
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const DeleteFile = async (form) => {
  const response = await $api.post(Endpoints.ProjectFileLog.DeleteFile(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## ProjectFileLog Delete File
/**
 *
 * @param {{id: string}} form
 
 * @returns
 */
export const ActivateFileLog = async (form) => {
  const response = await $api.post(
    Endpoints.ProjectFileLog.ActivateFileLog(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  DownloadFile,
  GetDirectoriesAndFiles,
  UploadFile,
  CompressFile,
  DeleteFile,
  ActivateFileLog,
};
